import { gql } from "@apollo/client";

export const GET_LIQUIDACIONES_RV_MAIL = gql`
    query GetLiquidacionesRvMail($input: LiquidacionRVFiltersInput!) {
        liquidacionesRvMail(input: $input) {
        success
        error
        valorEsperado{
            idLiquidacionProfesional
            profesional
            codigoSAPProfesional
            numeroOC
            periodo
            total
            esLegacy
        }
        }
    }
`;

export const REENVIAR_MAIL_LIQUIDACION = gql`
    mutation ReenviarMailLiquidacion($input: [ReenviarMailLiquidacionInput!]!) {
        reenviarMailLiquidacion(input: $input)
    }
`;
